import React from 'react';
import { Users, Star, Globe2 } from 'lucide-react';
export function SocialProof() {
  return <section className="py-8 border-y border-white/10 bg-brand-card/30" data-id="element-227">
      <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16" data-id="element-228">
        <div className="flex items-center space-x-3" data-id="element-229">
          <div className="bg-brand-gold/20 p-3 rounded-full" data-id="element-230">
            <Users className="w-6 h-6 text-brand-gold" data-id="element-231" />
          </div>
          <div data-id="element-232">
            <p className="text-white font-bold text-lg" data-id="element-233">+500 profesores</p>
            <p className="text-gray-400 text-sm" data-id="element-234">ya lo aplican</p>
          </div>
        </div>

        <div className="flex items-center space-x-3" data-id="element-235">
          <div className="bg-brand-gold/20 p-3 rounded-full" data-id="element-236">
            <Star className="w-6 h-6 text-brand-gold fill-brand-gold" data-id="element-237" />
          </div>
          <div data-id="element-238">
            <p className="text-white font-bold text-lg" data-id="element-239">4.9/5</p>
            <p className="text-gray-400 text-sm" data-id="element-240">satisfacción</p>
          </div>
        </div>

        <div className="flex items-center space-x-3" data-id="element-241">
          <div className="bg-brand-gold/20 p-3 rounded-full" data-id="element-242">
            <Globe2 className="w-6 h-6 text-brand-gold" data-id="element-243" />
          </div>
          <div data-id="element-244">
            <p className="text-white font-bold text-lg" data-id="element-245">12 países</p>
            <p className="text-gray-400 text-sm" data-id="element-246">alumnos globales</p>
          </div>
        </div>
      </div>
    </section>;
}